<div class="h5" *ngIf="helpText && helpText.header && helpText.header.text">{{helpText?.header?.text}}</div>

<div class="multiline-tooltip help-text-font-size" *ngFor="let line of helpText?.bodies">
	<div *ngIf="!line.listItem" [ngClass]="{ 'bold': line.bold }">{{line.text}}</div>
	<li *ngIf="line.listItem" [ngClass]="{ 'bold': line.bold }">{{line.text}}</li>
</div>

<div class="italic padding-top-xs help-text-font-size">{{helpText?.footer?.text}}</div>